var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uw-content',{attrs:{"title":"数据导入","padding":"20px"}},[_c('div',{staticStyle:{"display":"grid","grid-gap":"10px","grid-template-columns":"repeat(2, 1fr)"}},[_c('customer-import'),_c('crm-business-import'),_c('contract-import'),_c('pm-wo-import')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }